<div class="box-body">
  <div class="alert alert-warning alert-dismissible">
    <h1><i class="icon fa fa-ban"></i>403 FORBIDDEN</h1>
  </div>
</div>
